module.exports = __webpack_public_path__ + "img/close.d97fd34e.svg";